var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ch-steps"},_vm._l((_vm.steps),function(item,index){return _c('div',{key:index,staticClass:"ch-item"},[_c('div',{staticClass:"ch-item-li",class:_vm.active==index?'active':''},[_c('div',{staticClass:"ch-step"},[_vm._v(_vm._s(index+1))])]),_c('div',{staticClass:"ch-item-label"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }